import { createSlice } from '@reduxjs/toolkit';

export const appReleasesSlice = createSlice({
    name: 'appReleases',
    initialState: {
        app_releases_list: [],
        applications_for_select: [],
        app_release: null,
    },
    reducers: {
        setAppReleasesList: (state, action) => {
            state.app_releases_list = action.payload;
        },
        setApplicationsForSelect: (state, action) => {
            state.applications_for_select = action.payload;
        },
        setAppRelease: (state, action) => {
            state.app_release = action.payload;
        }
    }
});

export const { setAppReleasesList, setApplicationsForSelect, setAppRelease } = appReleasesSlice.actions;
